
import { useEffect, useRef, useState } from "react";
import { Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import { CloseInvoicePaymentPubSub, CurrencyIdPubSub, OpenInvoicePaymentPubSub, OpenInvoicePaymentPubSubPayload, OpenInvoiceRecibePubSubPayload } from "@utils/pubsubs/PubSub";
import LoadingScreen from "@components/content/LoadingScreen";
import { SuscriptionDataType } from "@/api/SuscriptionsApi";
import { InvoicesRecibeDataType } from "@/formTypes/InvoicesRecibeFormDataType";
import { DynamicFormRef } from "@mavichpe/dynamic-forms";
import { showAlert } from "@utils/Alert";
import { omitProperties } from "@utils/Utils";
import { checkInvoicePaymentTicketPrint } from "@utils/ticketPrintUtils";
import moment from "moment";
import InvoicesPaymentForm from "@components/forms/InvoicesPaymentForm";
import { InvoicePaymentApi, InvoicePaymentDataType } from "@/api/InvoicePaymentApi";
import { InvoiceApi } from "@/api/InvoiceApi";


type InvoicePaymentOffCanvasProps = {
    suscriptionData: SuscriptionDataType,
    onPaymentCreated?: (generateInvoice: InvoicePaymentDataType) => void,
} & DefaultOffCanvasProps

const InvoicePaymentOffCanvas = (props: InvoicePaymentOffCanvasProps) => {
    const { btnColor = "primary", className, suscriptionData, onPaymentCreated } = props;
    const [isOpen, setOpen] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [recibeDate, setRecibeDate] = useState<string>("");
    const [invoiceId, setInvoiceId] = useState<string>("");
    const [invoiceNumber, setInvoiceNumber] = useState<number>();
    const formRef = useRef<DynamicFormRef>(null);
    const [defaultData, setDefaultData] = useState<InvoicesRecibeDataType>({} as InvoicesRecibeDataType)

    useEffect(() => {
        const unsubscribe = OpenInvoicePaymentPubSub.subscribe(openOffCanvas);
        const unsubscribeClose = CloseInvoicePaymentPubSub.subscribe(closeOffCanvas);
        return () => {
            unsubscribe();
            unsubscribeClose();
        };
    }, []);

    const closeOffCanvas = async () => {
        setOpen(false);
    }
    const openOffCanvas = async (payload: OpenInvoicePaymentPubSubPayload) => {
        const { openOffCanvas = false } = payload;
        setOpen(openOffCanvas);
        if (openOffCanvas) {
            const today = moment();
            const formatDate = today.format("YYYY-MM-DD");
            const defaultData: InvoicesRecibeDataType = {
                fecha: formatDate,
                monto: payload.pendingAmount,
                currencyId: payload.currencyId
            }
            setInvoiceNumber(payload.invoiceNumero)
            setInvoiceId(payload.invoiceId)
            setRecibeDate(formatDate)
            setDefaultData(defaultData)
        }
    }

    const toogleOffCanvas = (newState: boolean) => {
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    const onOffCanvasOpened = () => {
        let formDefaultData = {
            ...defaultData
        }
        CurrencyIdPubSub.publish({ currencyId: `${formDefaultData.currencyId}` })
        formRef.current?.resetFormValue(formDefaultData)
    }

    const onInvoicePaymentSubmit = async (formData?: InvoicesRecibeDataType) => {
        if (formData) {
            const { monto: pendiente = 0 } = defaultData
            let motivo = `Pago Factura #${invoiceNumber}`
            const recibeMonto = Number(formData?.monto)

            let isPartialPayment = false

            if (pendiente > recibeMonto) {
                isPartialPayment = true
                motivo = `Abono a Factura #${invoiceNumber}`
            }

            setLoading(true)
            try {
                let invoicePayment: InvoicePaymentDataType = {
                    ...formData,
                    estado: 'active',
                    descripcion: motivo,
                    monto: Number(formData?.monto),
                    vuelto: 0,
                    created: recibeDate,
                    invoiceId: invoiceId,
                    exchangeRate: formData.exchange_rate
                }
                invoicePayment = omitProperties(invoicePayment, ["exchange_rate", "fecha"])

                const generatedPayment = await InvoicePaymentApi.create(invoicePayment)
                if (!isPartialPayment) {
                    const invoice = await InvoiceApi.get(invoiceId);
                    await InvoiceApi.update(invoiceId, {
                        status: "pagada",
                        pagada: true,
                        clientId: invoice.clientId,
                        fecha: invoice.fecha,
                        // `user` es parte del sort key `user#fecha`: se reenvia el guardado
                        // para no pisar al creador con quien registra el pago.
                        user: invoice.user
                    });
                }

                showAlert("success", `Se ha registrado el pago exitosamente`);
                if (onPaymentCreated) {
                    onPaymentCreated(generatedPayment);
                }
                checkInvoicePaymentTicketPrint(suscriptionData, generatedPayment)

            } catch (err) {
                if (err instanceof Error) {
                    showAlert("danger", err.message);
                }
            } finally {
                setLoading(false)
            }
        }
    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                type="button"
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            )}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onOpened={onOffCanvasOpened}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >
                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Agregar Pago a Factura
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <p>
                            Por favor ingrese la informacion de la forma de pago.
                        </p>
                        <InvoicesPaymentForm
                            ref={formRef}
                            onPaymentDateChange={(value) => setRecibeDate(value)}
                            onPaymentSubmit={onInvoicePaymentSubmit}
                            recibeTotal={Number(defaultData.monto || 0)}
                        />
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas >
            <LoadingScreen isLoading={isLoading} />
        </>
    );
}
export default InvoicePaymentOffCanvas;

